import { ClienteService } from '../../services/cliente.service';
import { DatosImportacionViewModel } from '../../models/viewmodels/datosImportacionViewModel';
var ImportarArchivosComponent = /** @class */ (function () {
    function ImportarArchivosComponent(clienteService) {
        this.clienteService = clienteService;
        this.historica = new DatosImportacionViewModel();
        this.aplicada = new DatosImportacionViewModel();
        this.alert = {
            tipo: "success",
            titulo: "",
            mensaje: "",
            visible: false
        };
    }
    ImportarArchivosComponent.prototype.ngOnInit = function () {
        this.spinner.isRunning = false;
        this.aplicada.enviar = true;
        this.historica.tipo = 1;
        this.aplicada.tipo = 0;
    };
    ImportarArchivosComponent.prototype.onChangeHistorica = function (event) {
        var target = event.target || event.srcElement; //if target isn't there then take srcElement
        var files = target.files;
        this.archivoHistorica = files[0];
    };
    ImportarArchivosComponent.prototype.onChangePdf = function (event) {
        var target = event.target || event.srcElement; //if target isn't there then take srcElement
        var files = target.files;
        this.archivoComprobantes = files[0];
    };
    ImportarArchivosComponent.prototype.onChangeAplicada = function (event) {
        var target = event.target || event.srcElement; //if target isn't there then take srcElement
        var files = target.files;
        this.archivoAplicada = files[0];
    };
    ImportarArchivosComponent.prototype.onChangeChkSaldo = function (event) {
        this.historica.tipo = event.target.checked ? 1 : 2;
    };
    ImportarArchivosComponent.prototype.onSubmitAplicada = function () {
        this.enviar(this.archivoAplicada, this.aplicada, this.archivoComprobantes);
    };
    ImportarArchivosComponent.prototype.onSubmit = function () {
        this.enviar(this.archivoHistorica, this.historica, null);
    };
    ImportarArchivosComponent.prototype.enviar = function (zip, datos, comprobantes) {
        var _this = this;
        this.spinner.isRunning = true;
        this.alert.visible = false;
        this.clienteService.importarCtaCte(zip, datos, comprobantes)
            .map(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = datos.tipo == 0 ? "Cuenta Corriente Aplicada" : "Cuenta Corriente Historica";
            if (result.status == 200) {
                _this.alert.tipo = "success";
                _this.alert.mensaje = "La importación se realizó correctamente";
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "La importación no se ha podido realizar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.spinner.isRunning = false;
            _this.fileInputHistorica.nativeElement.value = "";
            _this.fileInputAplicada.nativeElement.value = "";
            datos.sobrescribir = false;
            _this.historica.enviar = false;
        })
            .subscribe(function (data) {
        }, function (error) {
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = datos.tipo == 0 ? "Cuenta Corriente Aplicada" : "Cuenta Corriente Historica";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "La importación no se ha podido realizar. Por favor vuelva a intentarlo.";
        });
    };
    ImportarArchivosComponent.ctorParameters = function () { return [{ type: ClienteService }]; };
    return ImportarArchivosComponent;
}());
export { ImportarArchivosComponent };
//# sourceMappingURL=importar-archivos.component.js.map


// WEBPACK FOOTER //
// importar-archivos.component.js